/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".form-group[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{font-weight:600;color:#495057}.table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{font-size:.9rem}.table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{vertical-align:middle}.btn-sm[_ngcontent-%COMP%]{padding:.25rem .5rem;font-size:.875rem}.card[_ngcontent-%COMP%]{border:none;box-shadow:0 2px 4px rgba(0,0,0,.1)}.badge[_ngcontent-%COMP%]{font-size:.9rem;padding:.4rem .6rem}.alert[_ngcontent-%COMP%]{margin-top:1rem}\n/*# sourceMappingURL=porcentajes.component.css.map*/"];
export { styles as styles };
